import styled from 'styled-components/native';
import Text from '../../elements/Text';
const CheckBoxLabel = styled(Text) `
  padding-left: 8px;
  line-height: ${({ theme }) => theme.checkBoxTextLineHeight};
  ${props => props.customStyle}
`;
export default CheckBoxLabel;
